module.exports = __webpack_public_path__ + "static/media/volleyball-ball.989d7b29.svg";